// extracted by mini-css-extract-plugin
export var option = "_5m-1";
export var optionActive = "_5m-2";
export var pill = "_5m-0";